






























































import { Vue, Component } from "nuxt-property-decorator";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import CommonHelpers from "~/helpers/CommonHelpers";

@Component({
  components: { GrPublicFooter },
})
export default class SiteMapPage extends Vue {
  get rootUrl(): string {
    return CommonHelpers.getBaseUrl();
  }

  get imageUrl() {
    return "/bloggen/NY-BILD-768x1024.jpeg";
  }

  get description(): string {
    return "Lyckat samarbete mellan Gritify och Dagens Industri";
  }

  get title(): string {
    return "Lyckat samarbete";
  }

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          property: "og:title",
          content: this.title,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:image",
          content: `${this.rootUrl}${this.imageUrl}`,
        },
        {
          property: "og:url",
          content: `${this.rootUrl}${this.$route.path}`,
        },
        {
          property: "og:description",
          content: this.description,
        },
        {
          name: "twitter:title",
          content: this.title,
        },
        {
          name: "twitter:description",
          content: this.description,
        },
        {
          name: "twitter:image",
          content: `${this.rootUrl}${this.imageUrl}`,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  }
}
